export function NotFoundRoute() {
  return (
    <div>
      <h1>Not found</h1>
      <p>The requested page does not exist.</p>
    </div>
  )
}
